import React from 'react';

import './TermsAndConditions.css';

const TermsAndConditions = () => {
    return (
        <div className="tc container">
            <p className="tc-title">Terms And Conditions</p>
            <div className="tc-body">
                <p>All the Content uploaded to this website is generated under the tag Onerock visuals and Graphics and cannot be used without Prior Permission.</p>
                <p>Any person appearing in the content presented on the website could contact us through the contact page for update or removal of a specific part.</p>
                <p>Some Content Might Belong to a Institute or Organisation but is displayed on this website as it contains involvement of Onerock's team in editing and directing purposes.</p>
            </div>
        </div>
    );
};

export default TermsAndConditions;


// WEBPACK FOOTER //
// ./src/components/termsAndConditions/TermsAndConditions.js